import ResetPasswordExpiredPage from "./ResetPasswordExpiredPage";

export default ResetPasswordExpiredPage;
